export const TEMP_UPLOAD_SUCCESS = "TEMP_UPLOAD_SUCCESS";
export const TEMP_UPLOAD_ERROR = "TEMP_UPLOAD_ERROR";
export const TEMP_UPLOAD_RESET = "TEMP_UPLOAD_RESET";
